import { useStore } from 'effector-react'
import { uniq } from 'lodash'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { permissionModel } from '~/entities/common/Taxipark/Permission'
import { AddRole } from '~/features/common/Taxipark/Roles/AddRole'
import { Breadcrumbs, BreadcrumbsList } from '~/shared/ui/Breadcrumbs'
import { Container, PageTitle, PageContainer } from '~/shared/ui/Layout'
import { QuickNavigation } from '~/shared/ui/QuickNavigation'

const breadcrumbs: BreadcrumbsList = [
  { titleI18n: 'roles', link: '/taxipark/roles' },
  { titleI18n: 'create role' },
]

export const AddRolePage = () => {
  const { t } = useTranslation()

  const permissions = useStore(permissionModel.$permissions)

  const quickNavigationOptions = useMemo(() => {
    return uniq(
      (permissions || []).map((permission) => permission.groupTitle),
    ).map((title) => ({
      label: title,
      anchor: title,
    }))
  }, [permissions])

  return (
    <PageContainer title={t('create role')}>
      <Container isHeader>
        <Breadcrumbs list={breadcrumbs} />
        <PageTitle>{t('create role')}</PageTitle>
      </Container>
      <AddRole />

      {Boolean(permissions?.length) && (
        <QuickNavigation options={quickNavigationOptions} />
      )}
    </PageContainer>
  )
}
